import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/nightlifeLanding.css";

export default function WelcomeScreen() {
  useEffect(() => {
    document.body.classList.add("p2p-landing");
    return () => document.body.classList.remove("p2p-landing");
  }, []);

  const ROUTES = {
    accessCta: "/download",
    offerAccessCta: "/download",
  };

  // Optional tracking helper
  const fireEvent = (name, params = {}) => {
    try {
      if (!window.gtag) return;
      window.gtag("event", name, {
        page: "welcome",
        ...params,
      });
    } catch {}
  };

  return (
    <main className="nl">
      {/* Header */}
      <header className="nlTopbar">
        <div className="nlContainer nlTopbarInner">
          <div className="nlBrand">
            <img
              src="/images/logo.png"
              alt="Pay2Pee logo"
              className="nlBrandLogo"
            />
            <div>
              <div className="nlBrandName">Pay2Pee</div>
              <div className="nlBrandTag">
                Access is human. Keep it fair.
              </div>
            </div>
          </div>

          <nav className="nlNav">
            <Link to="/nightlife" className="nlNavLink">
              Nightlife
            </Link>
            <Link to="/access" className="nlNavLink">
              Partners
            </Link>
            <a href="#circle" className="nlBtn nlBtnGhost">
              How it works
            </a>
          </nav>
        </div>
      </header>

      {/* HERO */}
      <section className="nlHero" id="top">
        <div className="nlContainer">
          <h1 className="nlH1">
            <span className="nlBlue">Access</span> is human.
            <br />
            <span className="nlOrange">
              Pay2Pee keeps it fair.
            </span>
          </h1>

          <p className="nlSub">
            Sometimes you need a clean bathroom, fast! Sometimes you’re the place
            that can help. Pay2Pee makes that exchange simple, respectful, and
            affordable.
          </p>

          <div className="nlCtas">
            <a href="#choose" className="nlBtn nlBtnPrimary">
              Get started
            </a>
            <a href="#circle" className="nlBtn nlBtnSecondary">
              See the flow
            </a>
          </div>

          <div className="nlPills">
            <div className="nlPill">Dignified</div>
            <div className="nlPill">Low-cost</div>
            <div className="nlPill">On your terms</div>
            <div className="nlPill">Built for real life</div>
          </div>
        </div>
      </section>

      {/* FLOW */}
      <section className="nlSection nlAlt" id="circle">
        <div className="nlContainer">
          <h2 className="nlH2">A simple exchange</h2>
          <p className="nlMuted" style={{ marginTop: 6, lineHeight: 1.6 }}>
            Cities run on shared spaces. Pay2Pee turns bathroom access into a
            clear, respectful flow—so everyone wins.
          </p>

          <div className="nlSteps">
            <div className="nlStep">
              <div className="nlStepIcon">🚶🏾‍♀️</div>
              <h3>You need access</h3>
              <p>When it hits, it hits.</p>
            </div>

            <div className="nlStep">
              <div className="nlStepIcon">📍</div>
              <h3>Find nearby</h3>
              <p>No guessing, no stress.</p>
            </div>

            <div className="nlStep">
              <div className="nlStepIcon">🤝</div>
              <h3>Access granted</h3>
              <p>Clean, fast, reliable.</p>
            </div>

            <div className="nlStep">
              <div className="nlStepIcon">💸</div>
              <h3>Everyone wins</h3>
              <p>You get relief. They get paid.</p>
            </div>

            <div className="nlStep">
              <div className="nlStepIcon">🔁</div>
              <h3>Repeat</h3>
              <p>That’s the city.</p>
            </div>

            <div className="nlStep">
              <div className="nlStepIcon">🛡️</div>
              <h3>Clear rules</h3>
              <p>No awkward moments.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CHOOSE */}
      <section className="nlSection" id="choose">
        <div className="nlContainer">
          <h2 className="nlH2">Where do you fit today?</h2>

          <div className="nlGrid2">
            {/* NEED ACCESS */}
            <div className="nlBox">
              <h3>I need access</h3>
              <p>
                Find nearby bathrooms instantly. Pay digitally and keep moving.
              </p>

              <div className="nlCtas" style={{ marginTop: 14 }}>
                <Link
                  to={ROUTES.accessCta}
                  className="nlBtn nlBtnPrimary"
                  onClick={() =>
                    fireEvent("download_click", { type: "guest" })
                  }
                >
                  Download Now
                </Link>

                <Link to="/nightlife" className="nlBtn nlBtnSecondary">
                  Nightlife mode
                </Link>
              </div>
            </div>

            {/* OFFER ACCESS */}
            <div className="nlBox">
              <h3>I can offer access</h3>
              <p>
                Turn demand into revenue. Set your rules and earn passively.
              </p>

              <div className="nlCtas" style={{ marginTop: 14 }}>
                <Link
                  to={ROUTES.offerAccessCta}
                  className="nlBtn nlBtnPrimary"
                  onClick={() =>
                    fireEvent("download_click", { type: "partner" })
                  }
                >
                  Download Now
                </Link>

                <Link to="/access" className="nlBtn nlBtnSecondary">
                  Partner details
                </Link>
              </div>
            </div>
          </div>

          <div className="nlMuted" style={{ marginTop: 14, fontSize: 13 }}>
            Most locations charge between $1–$5 per visit.
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="nlFooter">
        <div className="nlContainer nlFooterInner">
          <div className="nlMuted">
            © {new Date().getFullYear()} Pay2Pee
          </div>

          <div className="nlFooterLinks">
            <a className="nlLink" href="#top">
              Back to top
            </a>
          </div>
        </div>
      </footer>
    </main>
  );
}